import { render, staticRenderFns } from "./TaskSelect.vue?vue&type=template&id=4f0f06a4&scoped=true"
import script from "./TaskSelect.vue?vue&type=script&lang=js"
export * from "./TaskSelect.vue?vue&type=script&lang=js"
import style0 from "./TaskSelect.vue?vue&type=style&index=0&id=4f0f06a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f06a4",
  null
  
)

export default component.exports